var classes = {"experienceCompareCardContainer":"bJULn","experienceCompareCardContentWrapper":"L4w7R","experienceCompareCardFeaturesContainer":"xva-t","experienceCompareCardColorSwatches":"ZslVy"};

export { classes as default };
